import { useTheme } from '@shopify/restyle';
import { ListingThumbnail } from 'app/components/listing-thumbnail';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { useScopedTranslation } from 'app/hooks/i18n';
import { Placeholder, PlaceholderLine, PlaceholderMedia, ShineOverlay } from 'app/overrides/rn-placeholder';
import { type Listing } from 'app/types/listing';
import { type ViewProps } from 'react-native';
import type { Theme } from 'app/shopify';

type HeaderSectionProps = Listing;

export function HeaderSection({ ...listing }: HeaderSectionProps) {
  const { t } = useScopedTranslation();

  return (
    <Row gap="spacing.general.x4">
      <ListingThumbnail {...listing} canZoomOnPhoto size={130} isFound={!!listing.lender} />

      <Column flex={1} gap="spacing.general.x1" justifyContent="center">
        <Text fontWeight="700" marginBottom="spacing.general.x3" numberOfLines={2} variant="bodyLarge">
          {listing.item.name}
        </Text>

        <Text numberOfLines={1} variant="bodyBase" width="100%">
          {t('headerSection.numOffers', {
            numOffers: listing.grouping?.totalOffers ?? listing.grouping?.listings.length,
          })}
        </Text>
      </Column>
    </Row>
  );
}

HeaderSection.Skeleton = function HeaderSectionSkeleton() {
  const theme = useTheme<Theme>();
  const borderRadiusLg = theme.borderRadii['radius.lg'];
  const marginEndX4 = theme.spacing['spacing.general.x4'];
  const leftElement = (props: ViewProps) => (
    <PlaceholderMedia
      style={[
        {
          height: 60,
          width: 60,
          borderRadius: borderRadiusLg,
          marginEnd: marginEndX4,
        },
        props.style,
      ]}
    />
  );

  return (
    <Row gap="spacing.general.x4">
      <Column flex={1} justifyContent="center">
        <Placeholder Animation={ShineOverlay} Left={leftElement}>
          <PlaceholderLine
            style={{
              height: 10,
              width: 200,
              borderRadius: theme.borderRadii['radius.lg'],
            }}
          />
          <PlaceholderLine
            style={{
              height: 10,
              width: 35,
              borderRadius: theme.borderRadii['radius.lg'],
              marginTop: theme.spacing['spacing.general.x1'],
            }}
          />

          <PlaceholderLine
            style={{
              width: 125,
              height: 10,
              borderRadius: theme.borderRadii['radius.lg'],
            }}
          />
        </Placeholder>
      </Column>
    </Row>
  );
};
